import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PriceComponent } from '@df/ui/price/price.component';
import { TranslatePipe } from '@df/ui/translation/translate.pipe';
import { ActionComponent } from '../../../ui/api/action.component';
import { StoreCreditToggleComponentDef } from '../store-credit-toggle.component.def';

@Component({
    selector: 'store-credit-remove',
    templateUrl: './store-credit-remove.component.html',
    standalone: true,
    imports: [ActionComponent, CommonModule, PriceComponent, TranslatePipe],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class StoreCreditRemoveComponent extends StoreCreditToggleComponentDef {}
